import React from "react";
import "./NcvtePage.css";
import BannerImage from "../Component/ChatGPT Image Nov 19, 2025, 08_20_53 PM.png"; // ✅ Replace with your actual banner image

const NcvtePage = () => {
  return (
    <div className="ncvte-page">
      {/* 🔹 Banner Section */}
      <div className="ncvte-banner">
        <img src={BannerImage} alt="NCVTE Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 ncvte-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About NCVTE (National Council for Vocational Training in Education)
        </h2>

        <p>
          The National Council for Vocational Training in Education (NCVTE) is an autonomous body
          dedicated to promoting and standardizing vocational education and training across India.
          Its mission is to equip students with industry-relevant skills and certifications that
          enhance employability and align with the evolving needs of various sectors. CPIT, as an
          NCVTE-recognized training institution, provides structured programs designed to develop
          technical and professional expertise among learners.
        </p>

        <p>
          NCVTE courses at CPIT cover a wide range of fields, including Information Technology,
          Accounting, Office Management, Graphic Design, and Communication Skills. The curriculum
          is designed to provide a perfect balance between theoretical understanding and practical
          exposure, ensuring that students gain both knowledge and confidence to succeed in their
          chosen professions.
        </p>

        <p>
          Each NCVTE-certified program emphasizes hands-on experience and real-world applications.
          Students are trained by industry experts through workshops, lab sessions, and live
          projects that simulate workplace challenges. This approach not only enhances technical
          competency but also fosters creativity, discipline, and teamwork—qualities essential in
          today’s competitive job market.
        </p>

        <p>
          After successful completion, students receive NCVTE-approved diplomas and certificates
          recognized across India and abroad. These credentials open doors to employment
          opportunities in both government and private sectors. Through its NCVTE partnership, CPIT
          continues to empower individuals with skills that create pathways for professional growth,
          entrepreneurship, and lifelong learning.
        </p>
      </div>
    </div>
  );
};

export default NcvtePage;
